import React from 'react';
import I18n from '../i18n';
import { chunkedMedicard } from '../utils';

export const Title = ({ children, keys }) => (
  <h2
    style={{
      fontWeight: '400',
      fontFamily: "'Fedra', sans-serif",
      margin: '25px 0 15px 0',
      fontSize: '24px'
    }}
  >
    {children}
    {keys ? <I18n keys={keys} /> : null}
  </h2>
);

const PatientHeader = ({ patientName, medicardNumber }) => (
  <Title>
    {patientName ? patientName : ''}
    {patientName && medicardNumber ? ' | ' : ''}
    {medicardNumber ? chunkedMedicard(medicardNumber) : ''}
  </Title>
);

export default PatientHeader;
